exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#addVarianceModal .v--modal-box.v--modal{min-height:410px!important;min-width:400px!important}#addVarianceModal .modal__content{overflow-y:auto!important}#addVarianceModal .v-select__selection.v-select__selection--comma,#addVarianceModal .v-text-field__slot input,#addVarianceModal .v-text-field__slot label,#addVarianceModal div.v-select__slot>label{font-size:12px!important}#addVarianceModal .v-subheader{font-size:14px!important;color:#000!important;font-weight:600!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-034d8a17","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/start/modals/variances/AddVariance.vue
// module id = 2110
// module chunks = 0